
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/expert",
      function () {
        return require("private-next-pages/signup/expert.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/expert"])
      });
    }
  